<template>
  <router-view :open2="open2" />
</template>

<script>
export default {
  name: "ConTent",
  props: ["open2"],
};
</script>